import { TissueCharacteristicsProps } from '../../../../models';
import { TableColumn } from '../../../../../../core/components/table';

export const COLUMN_KEYS = Object.freeze({
  type: 'type',
  t1: 't1',
  t2: 't2',
} as const);

export const generateColumns = (
  editableTableColumnsPorperties?: Partial<TableColumn<TissueCharacteristicsProps>>
): Array<TableColumn<TissueCharacteristicsProps>> => {
  const columns: Array<TableColumn<TissueCharacteristicsProps>> = [
    {
      title: 'Tissue Name',
      key: COLUMN_KEYS.type,
      enableSort: false,
    },
    {
      title: 'T1 (msec)',
      key: COLUMN_KEYS.t1,
      enableSort: false,
      customContent: true,
      ...editableTableColumnsPorperties,
    },
    {
      title: 'T2 (msec)',
      key: COLUMN_KEYS.t2,
      enableSort: false,
      customContent: true,
      ...editableTableColumnsPorperties,
    },
  ];

  return columns;
};
